import { z } from 'zod'

import { PushClientType } from '../constants/push'
import { dbEntitySchema } from './system'

export const pushSchema = dbEntitySchema.extend({
  token: z.string(),
  type: z.nativeEnum(PushClientType),
  device: z.string().optional().nullable(),
  managementUser: z.string().optional().nullable(),
  user: z.string().optional().nullable(),
})

export const pushCreateOrUpdateArgsSchema = z.object({
  token: z.string(),
  type: z.nativeEnum(PushClientType),
  device: z.string().optional(),
})

export type PushCreateOrUpdateArgs = z.infer<
  typeof pushCreateOrUpdateArgsSchema
>
